// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RestaurantAccessPicker {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.RestaurantAccessPicker__section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.RestaurantAccessPicker__label {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.RestaurantAccessPicker__empty,
.RestaurantAccessPicker__results-empty {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 13px;
  color: #898989;
  padding: 8px 0;
}

.RestaurantAccessPicker__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.RestaurantAccessPicker__chip {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  padding: 8px 10px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  background: #fafafa;
}

.RestaurantAccessPicker__chip-main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.RestaurantAccessPicker__chip-title {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.RestaurantAccessPicker__chip-meta {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 11px;
  color: #898989;
}

.RestaurantAccessPicker__chip-remove {
  border: none;
  background: none;
  color: #898989;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}

.RestaurantAccessPicker__chip-remove:hover {
  color: #e621d3;
}

.RestaurantAccessPicker__link {
  align-self: flex-start;
  border: none;
  background: none;
  color: #e621d3;
  font-family: "Montserrat Regular", sans-serif;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
}

.RestaurantAccessPicker__network-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.restaurant-access-network__control {
  flex: 1;
  min-height: 40px !important;
  border-radius: 8px !important;
  border-color: #e3e3e3 !important;
}

.restaurant-access-network__menu {
  z-index: 20;
}

.RestaurantAccessPicker__button {
  white-space: nowrap;
  border: none;
  border-radius: 8px;
  background: #e621d3;
  color: #fff;
  font-family: "Montserrat Regular", sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 14px;
  cursor: pointer;
}

.RestaurantAccessPicker__button:disabled {
  background: #e0e0e0;
  color: #888;
  cursor: not-allowed;
}

.RestaurantAccessPicker__search {
  width: 100%;
  height: 40px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  padding: 0 12px;
  font-family: "Montserrat Regular", sans-serif;
  font-size: 14px;
  outline: none;
}

.RestaurantAccessPicker__search:focus {
  border-color: #e621d3;
}

.RestaurantAccessPicker__results {
  display: flex;
  flex-direction: column;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
}

.RestaurantAccessPicker__result {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.RestaurantAccessPicker__result:last-child {
  border-bottom: none;
}

.RestaurantAccessPicker__result:hover {
  background: #faf5fb;
}

.RestaurantAccessPicker__result-title {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #111;
}

.RestaurantAccessPicker__result-meta {
  font-family: "Montserrat Regular", sans-serif;
  font-size: 12px;
  color: #898989;
}

@media (max-width: 768px) {
  .RestaurantAccessPicker__network-row {
    flex-direction: column;
    align-items: stretch;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/RestaurantAccessPicker/RestaurantAccessPicker.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;;EAEE,6CAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,6CAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,6CAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,6CAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE;IACE,sBAAA;IACA,oBAAA;EACF;AACF","sourcesContent":[".RestaurantAccessPicker {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.RestaurantAccessPicker__section {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.RestaurantAccessPicker__label {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.RestaurantAccessPicker__empty,\n.RestaurantAccessPicker__results-empty {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 13px;\n  color: #898989;\n  padding: 8px 0;\n}\n\n.RestaurantAccessPicker__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.RestaurantAccessPicker__chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  padding: 8px 10px;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  background: #fafafa;\n}\n\n.RestaurantAccessPicker__chip-main {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.RestaurantAccessPicker__chip-title {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: #111;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.RestaurantAccessPicker__chip-meta {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 11px;\n  color: #898989;\n}\n\n.RestaurantAccessPicker__chip-remove {\n  border: none;\n  background: none;\n  color: #898989;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.RestaurantAccessPicker__chip-remove:hover {\n  color: #e621d3;\n}\n\n.RestaurantAccessPicker__link {\n  align-self: flex-start;\n  border: none;\n  background: none;\n  color: #e621d3;\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.RestaurantAccessPicker__network-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.restaurant-access-network__control {\n  flex: 1;\n  min-height: 40px !important;\n  border-radius: 8px !important;\n  border-color: #e3e3e3 !important;\n}\n\n.restaurant-access-network__menu {\n  z-index: 20;\n}\n\n.RestaurantAccessPicker__button {\n  white-space: nowrap;\n  border: none;\n  border-radius: 8px;\n  background: #e621d3;\n  color: #fff;\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 14px;\n  cursor: pointer;\n}\n\n.RestaurantAccessPicker__button:disabled {\n  background: #e0e0e0;\n  color: #888;\n  cursor: not-allowed;\n}\n\n.RestaurantAccessPicker__search {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n  padding: 0 12px;\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 14px;\n  outline: none;\n}\n\n.RestaurantAccessPicker__search:focus {\n  border-color: #e621d3;\n}\n\n.RestaurantAccessPicker__results {\n  display: flex;\n  flex-direction: column;\n  max-height: 220px;\n  overflow-y: auto;\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n}\n\n.RestaurantAccessPicker__result {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-bottom: 1px solid #f0f0f0;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n}\n\n.RestaurantAccessPicker__result:last-child {\n  border-bottom: none;\n}\n\n.RestaurantAccessPicker__result:hover {\n  background: #faf5fb;\n}\n\n.RestaurantAccessPicker__result-title {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  color: #111;\n}\n\n.RestaurantAccessPicker__result-meta {\n  font-family: 'Montserrat Regular', sans-serif;\n  font-size: 12px;\n  color: #898989;\n}\n\n@media (max-width: 768px) {\n  .RestaurantAccessPicker__network-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"RestaurantAccessPicker": `RestaurantAccessPicker`,
	"RestaurantAccessPicker__section": `RestaurantAccessPicker__section`,
	"RestaurantAccessPicker__label": `RestaurantAccessPicker__label`,
	"RestaurantAccessPicker__empty": `RestaurantAccessPicker__empty`,
	"RestaurantAccessPicker__results-empty": `RestaurantAccessPicker__results-empty`,
	"RestaurantAccessPicker__chips": `RestaurantAccessPicker__chips`,
	"RestaurantAccessPicker__chip": `RestaurantAccessPicker__chip`,
	"RestaurantAccessPicker__chip-main": `RestaurantAccessPicker__chip-main`,
	"RestaurantAccessPicker__chip-title": `RestaurantAccessPicker__chip-title`,
	"RestaurantAccessPicker__chip-meta": `RestaurantAccessPicker__chip-meta`,
	"RestaurantAccessPicker__chip-remove": `RestaurantAccessPicker__chip-remove`,
	"RestaurantAccessPicker__link": `RestaurantAccessPicker__link`,
	"RestaurantAccessPicker__network-row": `RestaurantAccessPicker__network-row`,
	"restaurant-access-network__control": `restaurant-access-network__control`,
	"restaurant-access-network__menu": `restaurant-access-network__menu`,
	"RestaurantAccessPicker__button": `RestaurantAccessPicker__button`,
	"RestaurantAccessPicker__search": `RestaurantAccessPicker__search`,
	"RestaurantAccessPicker__results": `RestaurantAccessPicker__results`,
	"RestaurantAccessPicker__result": `RestaurantAccessPicker__result`,
	"RestaurantAccessPicker__result-title": `RestaurantAccessPicker__result-title`,
	"RestaurantAccessPicker__result-meta": `RestaurantAccessPicker__result-meta`
};
export default ___CSS_LOADER_EXPORT___;
